import { Box, SxProps } from '@mui/material';
import { useStore } from '@priolo/jon';
import Paragraph from 'components/controls/form/Paragraph';
import { FunctionComponent } from 'react';
import dialogSo from 'stores/cycle/editDialog';
import farmSo from 'stores/farm';
import { getGrowUnitLayerName, getLayerByNumber } from 'stores/growUnit/utils/layer';
import { groupLayersByPhases } from "stores/phase/layers";
import { PHASE_SLUG, getPhaseLabel } from 'stores/phase/utils';
import { Layer } from 'types/Layer';
import ChipLayerCmp from './ChipLayerCmp';
import draftSo from 'stores/draft';



/**
 * Visualizza i LAYER raggruppati per PHASEs di un CYCLE
 */
const CycleLayersShow: FunctionComponent = () => {

	// STORE
	const dialogSa = useStore(dialogSo)

	// HOOKs

	// HANDLERS
	const handleLayerClick = (phase: string, layer: Layer) => {
		const index = phasesGroups[phase]
			.sort((a, b) => a.layerNumber - b.layerNumber)
			.findIndex(l => l.layerNumber == layer.layerNumber)

		let layersNumber = Object.entries(phasesGroups).map(([phase, layers]) => {
			const layer = layers.sort((a, b) => a.layerNumber - b.layerNumber)[index]
			return layer?.layerNumber
		}).filter(layerNumber => layerNumber != null)

		const layersSelected = [...dialogSa.layersNumberSelected]
		for (const layer of layersNumber) {
			const index = layersSelected.indexOf(layer)
			if (index == -1) {
				layersSelected.push(layer)
			} else {
				layersSelected.splice(index, 1)
			}
		}

		dialogSo.setLayersNumberSelected(layersSelected)
	}

	// RENDER
	// i LAYERs raggruppati per PHASE
	const phasesGroups = groupLayersByPhases<Layer>(dialogSa.cycle.layers)
	// i nomi dei layer utilizzati da questo CYCLE
	const getNameLayer = (layer: Layer) => {
		const growUnit = farmSo.getGrowUnit(dialogSa.cycle.growUnitId ?? layer.growUnitId)
		return getGrowUnitLayerName(growUnit, getLayerByNumber(growUnit, layer.layerNumber))
	}
	const phases = Object.keys(phasesGroups)
	const layerIsSelected = (layerNumber: number) => dialogSa.layersNumberSelected.includes(layerNumber)

	const isSplitEditable = draftSo.isEditable()
	const flex = 25

	return <>{
		phases.map(phase => (
			<Paragraph key={phase} flex={flex}
				sx={{ alignItems: "start" }}
				sxLabel={{ mt: "5px" }}
				title={phase != PHASE_SLUG.BATCH ? getPhaseLabel(phase)?.toUpperCase() : ""}
			>
				<Box sx={sxRow}>
					{phasesGroups[phase].map((layer) => (

						<ChipLayerCmp key={layer.layerNumber}
							label={getNameLayer(layer)}
							selected={layerIsSelected(layer.layerNumber)}
							readonly={!isSplitEditable}
							onClick={isSplitEditable ? () => handleLayerClick(phase, layer) : undefined}
						/>

					))}
				</Box>
			</Paragraph>
		))
	}</>

}

export default CycleLayersShow

const sxRow: SxProps = {
	display: "flex",
	margin: "5px 0px",
	flexWrap: "wrap",
	gap: 1,
}
